import type { Theme } from '@mui/material/styles';

export const contentPageRootSx = (theme: Theme) => ({
  [theme.breakpoints.down('md')]: {
    height: 'fit-content',
    minHeight: '100vh',
    flex: '0 0 auto',
  },
  [theme.breakpoints.up('md')]: {
    height: 'auto',
    minHeight: '100%',
    flex: '1 1 auto',
  },
});

export const contentPageScrollAreaSx = (theme: Theme) => ({
  [theme.breakpoints.down('md')]: {
    height: 'fit-content',
    minHeight: '100vh',
    flexGrow: 0,
    overflow: 'visible',
  },
  [theme.breakpoints.up('md')]: {
    overflow: 'visible',
    minHeight: 'auto',
  },
});

export const contentPageWrapperSx = (theme: Theme) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: '72vw',
    mx: 'auto',
    alignSelf: 'center',
  },
  [theme.breakpoints.down('md')]: {
    padding: 0,
    minHeight: '100vh',
    height: 'fit-content',
    flex: 'none',
  },
});

export const contentPageOuterContainerSx = (theme: Theme) => ({
  [theme.breakpoints.down('md')]: {
    margin: 0,
    minHeight: '100vh',
    height: 'fit-content',
    flex: 'none',
  },
});

export const contentPageInnerContainerSx = (theme: Theme) => ({
  [theme.breakpoints.down('md')]: {
    minHeight: '100vh',
    height: 'fit-content',
    flex: 'none',
  },
});
